import React, { useState, useEffect } from "react";
import { Button } from "primereact/button";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { FilterMatchMode } from "primereact/api";
import LoadingOverlay from "react-loading-overlay";
import { Triangle } from "react-loader-spinner";
import { InputText } from "primereact/inputtext";
import { handleGetRequest } from "../../services/GetTemplate";
import { useDispatch } from "react-redux";
import { confirmDialog } from "primereact/confirmdialog";
import { useHistory } from "react-router-dom";
import { SplitButton } from "primereact/splitbutton";
import { handleDeleteRequest } from "../../services/DeleteTemplate";
import { Image } from "primereact/image";
import { baseURL } from "../../Config";

const ManageCategory = () => {

    const history = useHistory()
    const dispatch = useDispatch()

    const [isActive, setIsActive] = useState(false)
    const [allCategories, setAllCategories] = useState([]);
    const [acceptButtonClass, setAcceptButtonClass] = useState('p-button-danger');

    const [globalFilterValue, setGlobalFilterValue] = useState("");
    const [filters, setFilters] = useState({
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    });

    const onGlobalFilterChange = (e) => {
        const value = e.target.value;
        let _filters = { ...filters };
        _filters["global"].value = value;

        setFilters(_filters);
        setGlobalFilterValue(value);
    };

    const actionTemplate = (rowData) => {
        const items = [
            {
                label: 'Edit',
                command: () => handleEditCategory(rowData),
            },
            {
                label: 'Delete',
                command: () => confirm(rowData),
            },
        ];
        return (
            <div className="">
                <SplitButton label="" model={items} />
            </div>
        );
    };

    const confirm = (rowData) => {
        confirmDialog({
            message: 'Are you sure you want to delete this Category?',
            header: 'Confirmation',
            icon: 'pi pi-exclamation-triangle',
            acceptClassName: acceptButtonClass,
            acceptLabel: 'Yes',
            accept: () => {
                handleDeleteCategory(rowData);
            },
            reject: () => {
                return null;
            },
        });
    };

    const handleDeleteCategory = async (rowData) => {
        setIsActive(true);
        const response = await dispatch(handleDeleteRequest(`/category/${rowData?._id}`, true, true));
        if (response?.status === 'success' || response?.statusCode === 200) {
            await getCategoryList();
        }
        setIsActive(false);
    };

    const handleEditCategory = (rowData) => {
        const item = true;
        history.push({
            pathname: './addeditcategory',
            state: {
                isEditable: item,
                rowData: rowData,
            }
        });
    };

    //Get Category List
    const getCategoryList = async () => {
        setIsActive(true);
        const response = await dispatch(handleGetRequest(`/category/getAll`, true));
        if (response?.status === 'success' || response?.statusCode === 200) {
            setAllCategories(response?.data || []);
        }
        setIsActive(false);
    };

    useEffect(() => {
        getCategoryList()
    }, [])

    const dateTemplate = (rowData) => {
        if (rowData?.createdAt) {
            const date = new Date(rowData.createdAt);
            return date.toLocaleDateString('en-US', { 
                year: 'numeric', 
                month: 'short', 
                day: 'numeric' 
            });
        }
        return 'N/A';
    };

    const imageTemplate = (rowData) => {
        return (
            <React.Fragment>
                {rowData?.image ? (
                    <Image
                        src={`${baseURL}/${rowData.image}`}
                        alt="Category"
                        width="50"
                        height="50"
                        preview
                        imageStyle={{ borderRadius: '4px', objectFit: 'cover' }}
                    />
                ) : (
                    <span style={{ color: '#999' }}>No Image</span>
                )}
            </React.Fragment>
        );
    };

    return (
        <>
            <div className="flex flex-column align-items-start md:flex-row  md:justify-content-between md:align-items-center ">
                <h4 className="mb-0" style={{ fontWeight: '600', letterSpacing: '0.5px', color: 'black' }}>
                    Categories Management
                </h4>
                <div className="flex flex-column align-items-start  md:flex-row md:align-items-center">
                    <span className="p-input-icon-left mr-3 resp-margin my-3 md:my-0">
                        <i className="pi pi-search" />
                        <InputText
                            placeholder="Search"
                            value={globalFilterValue}
                            onChange={onGlobalFilterChange}
                            className="search-input"
                        />
                    </span>
                    <div className="">
                        <Button
                            label="Add New Category"
                            className="Add__New-Button ml-3"
                            icon="pi pi-plus"
                            onClick={() => {
                                const item = false;
                                history.push({
                                    pathname: './addeditcategory',
                                    state: {
                                        isEditable: item,
                                    }
                                });
                            }}
                        />
                    </div>
                </div>
            </div>

            <div className="card mt-3">
                <LoadingOverlay
                    active={isActive}
                    spinner={<Triangle
                        height="120"
                        width="120"
                        color="#dc2626"
                        ariaLabel="triangle-loading"
                        wrapperStyle={{}}
                        wrapperClassName=""
                        visible={true}
                    />}
                    styles={{
                        overlay: (base) => ({
                            ...base,
                            background: 'rgb(38 41 51 / 78%)',
                        })
                    }}
                >
                    <DataTable
                        responsive={true}
                        filters={filters}
                        globalFilterFields={[
                            "name",
                            "desc",
                        ]}
                        responsiveLayout="scroll"
                        stripedRows
                        paginator
                        rows={20}
                        value={allCategories}
                        emptyMessage="No categories found"
                        paginatorClassName="custom-paginator"
                        paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                        currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                        rowsPerPageOptions={[10, 20, 30, 40, 50]}
                    >
                        <Column body={imageTemplate} header="Image"></Column>
                        <Column sortable field='name' body={(rowData) => rowData?.name || 'N/A'} header="Category Name"></Column>
                        <Column sortable field='desc' body={(rowData) => rowData?.desc || 'N/A'} header="Description"></Column>
                        <Column field='createdAt' body={dateTemplate} header="Created Date"></Column>
                        <Column header="Action" body={actionTemplate} />
                    </DataTable>
                </LoadingOverlay>
            </div>
        </>
    );
};

export default ManageCategory;

